import VersionUpdateModalComp , { versionupdate } from './version_update_modal'

export default VersionUpdateModalComp
export { VersionUpdateModalComp , versionupdate }